var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconSyringe(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_syringe"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon_syringe_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M6.57202 25.4287L12.2289 19.7719",
    stroke: "#582CDB",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    d: "M12.2289 19.7718C13.791 21.3339 16.3237 21.3339 17.8858 19.7718L22.5998 15.0578",
    stroke: "#865CFF",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    d: "M12.229 19.7709C10.6668 18.2088 10.6668 15.6761 12.229 14.1141L16.9431 9.4",
    stroke: "#865CFF",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M15.5876 6.98373C15.2947 6.69084 14.8198 6.69084 14.5269 6.98373C14.234 7.27663 14.234 7.7515 14.5269 8.04439L15.5876 6.98373ZM23.9551 17.4725C24.2479 17.7654 24.7228 17.7654 25.0157 17.4725C25.3086 17.1796 25.3086 16.7047 25.0157 16.4119L23.9551 17.4725ZM18.2982 10.7555C18.0054 11.0484 18.0054 11.5233 18.2983 11.8162C18.5912 12.109 19.066 12.109 19.3589 11.8161L18.2982 10.7555ZM23.5426 6.57177L24.0729 7.1021L24.0729 7.10209L23.5426 6.57177ZM25.4282 6.57177L25.9585 6.04146L25.9585 6.04145L25.4282 6.57177ZM25.4282 8.4574L25.9585 8.98772L25.9585 8.98771L25.4282 8.4574ZM20.1839 12.6411C19.891 12.934 19.891 13.4089 20.1839 13.7018C20.4767 13.9947 20.9516 13.9947 21.2445 13.7018L20.1839 12.6411ZM14.5269 8.04439L23.9551 17.4725L25.0157 16.4119L15.5876 6.98373L14.5269 8.04439ZM19.3589 11.8161L24.0729 7.1021L23.0123 6.04144L18.2982 10.7555L19.3589 11.8161ZM24.0729 7.10209C24.3007 6.8743 24.6701 6.8743 24.8978 7.10209L25.9585 6.04145C25.145 5.22785 23.8258 5.22785 23.0122 6.04145L24.0729 7.10209ZM24.8978 7.10208C25.1256 7.3299 25.1256 7.69927 24.8978 7.92709L25.9585 8.98771C26.7721 8.17411 26.7721 6.85506 25.9585 6.04146L24.8978 7.10208ZM24.8979 7.92707L20.1839 12.6411L21.2445 13.7018L25.9585 8.98772L24.8979 7.92707Z",
    fill: "#582CDB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 242",
    d: "M14 15.4286C15.3017 16.8233 16.0316 17.6053 17.3333 19M18 14L20 16.1429",
    stroke: "#7AFFC7",
    strokeWidth: 1.3
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSyringe);
export default __webpack_public_path__ + "static/media/Icon_syringe.55382dd3c1f9d624252cb32b43f3c824.svg";
export { ForwardRef as ReactComponent };